import React from 'react';
import cn from 'clsx';

import { LaptopSolidIcon } from '../../shared/icons/icons';
import Flag from '../flag/flag';

import styles from './web-only-flag.scss';

interface WebOnlyFlagProps {
  className?: string;
  hideLabel?: boolean;
}

function WebOnlyFlag(props: WebOnlyFlagProps) {
  const { className = '', hideLabel = false } = props;

  return (
    <Flag
      className={cn(styles['flag'], `web-only-flag ${className}`)}
      key="web-only"
      renderIcon={
        <LaptopSolidIcon
          className={cn(styles['flag-icon'], 'web-only-flag__flag-icon')}
        />
      }
    >
      {!hideLabel ? 'ONLINE ONLY' : ''}
    </Flag>
  );
}

export default WebOnlyFlag;
